/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Flex } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import { GoalRecommendationModal } from '@/modules/advisors/users/pages/components/GoalRecommendationModal/GoalRecommendationModal'
import { AdvisorUsersRoutePathsEnum } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig.types'

import { Button } from '@/components/Button/Button'
import { Disclaimer } from '@/components/Disclaimer/Disclaimer'
import { Loader } from '@/components/Loader/Loader'
import { MoreDropdown } from '@/components/MoreDropdown/MoreDropdown'
import { Table } from '@/components/Table/Table'
import { Text } from '@/components/Text/Text'

import { useAdvisorsServiceAdvisorUsersControllerGetUsers } from '@/__generated__/queries'
import type { UserData } from '@/__generated__/requests'

export function Component() {
  const [selectedUser, setSelectedUser] = useState<UserData | undefined>(
    undefined,
  )

  const [opened, { close, open }] = useDisclosure()

  const navigate = useNavigate()

  const { data, isLoading } = useAdvisorsServiceAdvisorUsersControllerGetUsers()

  if (!data || isLoading) return <Loader />

  if (data.length < 1) return <Disclaimer title="No users" />

  const handleNavigateToUserChat = (userId: UserData['id']) => {
    if (userId) {
      navigate(AdvisorUsersRoutePathsEnum.CHAT, { state: { userId } })
    }
  }

  const columns = [
    {
      key: 'name',
      label: 'Name',
      size: '100%',
    },
    {
      key: 'actions',
      label: 'Actions',
    },
  ]

  const handleViewDetailsClick = (userId: UserData['id']) => {
    navigate(
      `${AdvisorUsersRoutePathsEnum.USER.replace(':id', userId.toString())}`,
    )
  }

  const handleRecommendationModalOpen = (item: UserData) => {
    setSelectedUser(item)
    open()
  }

  const rows = data.map(item => [
    <Text key={`user-${item.id}`} variant="body_3">
      {item.firstName} {item.lastName}
    </Text>,
    <Flex key={`actions-${item.id}`} align="center">
      <Button
        h={32}
        miw={100}
        mr={8}
        onClick={() => handleViewDetailsClick(item.id)}
        size="compact-md"
      >
        View details
      </Button>

      <MoreDropdown
        items={[
          {
            label: 'Chat with user',
            onClick: () => handleNavigateToUserChat(item.id),
          },
          {
            label: 'Add goal',
            onClick: () => handleRecommendationModalOpen(item),
          },
        ]}
      />
    </Flex>,
  ])

  return (
    <>
      <Table columns={columns} rows={rows} />

      <GoalRecommendationModal
        onClose={close}
        opened={opened}
        user={selectedUser}
      />
    </>
  )
}

Component.displayName = 'Users'
